  (function(){
    var root = document.querySelector('.we-blog-redesign');
    if(!root) return;

    /* ---- Copy article link ---- */
    window.wbCopyLink = function(btn){
      var url = (btn && btn.getAttribute('data-url')) || window.location.href;
      function fallback(){
        var ta = document.createElement('textarea');
        ta.value = url; ta.style.position = 'fixed'; ta.style.opacity = '0';
        document.body.appendChild(ta); ta.focus(); ta.select();
        try{ document.execCommand('copy'); }catch(e){}
        document.body.removeChild(ta);
      }
      if(navigator.clipboard && navigator.clipboard.writeText){
        navigator.clipboard.writeText(url).catch(fallback);
      } else {
        fallback();
      }
    };

    /* ---- Instagram share: use the native share sheet (mobile picks Instagram),
            fall back to copying the link on desktop where IG has no web share. */
    window.wbShareArticle = function(btn){
      var url = (btn && btn.getAttribute('data-url')) || window.location.href;
      var title = (btn && btn.getAttribute('data-title')) || document.title;
      if(navigator.share){
        navigator.share({ title: title, url: url }).catch(function(){});
      } else if(navigator.clipboard && navigator.clipboard.writeText){
        navigator.clipboard.writeText(url).catch(function(){ window.wbCopyLink(btn); });
      } else {
        window.wbCopyLink(btn);
      }
    };

    /* ---- Mobile-first image loading ----
       Decoded images are the heaviest memory cost on long posts and the main
       trigger for the WebKit content-process crash seen on phones. Defer
       off-screen images and decode them off the main thread so low-power mobile
       devices aren't forced to hold every image in memory at once. Feature-
       detected and applied to all devices; the hero stays eager as the LCP. */
    if('loading' in HTMLImageElement.prototype){
      Array.prototype.forEach.call(root.querySelectorAll('img'), function(img){
        if(img.closest('.wb-hero')) return;
        if(!img.getAttribute('loading')) img.setAttribute('loading', 'lazy');
        img.setAttribute('decoding', 'async');
      });
    }

    /* ---- CLS guard for in-content images ----
       Merchant HTML images frequently ship with no width/height, so the browser
       reserves no space and text jumps as each one lazy-loads — a top mobile CLS
       source on long posts. For images that lack explicit dimensions we stamp an
       aspect-ratio so the box keeps its shape (with .wb-body img{max-width:100%;
       height:auto}, a full-width image then reserves its height BEFORE loading):
         1) parse the Shopify CDN url for its real dimensions (…_1024x768. or
            ?width=&height=) → reserves space up-front, preventing the shift;
         2) otherwise fall back to the natural size once decoded (fixes repeat
            visits + resize reflow). Ratios are the image's own, so no distortion. */
    var wbBodyEl = root.querySelector('.wb-body');
    if(wbBodyEl){
      Array.prototype.forEach.call(wbBodyEl.querySelectorAll('img'), function(img){
        if((img.getAttribute('width') && img.getAttribute('height')) || img.style.aspectRatio) return;
        var src = img.getAttribute('src') || img.getAttribute('data-src') || '';
        var m = src.match(/[_\/](\d{2,5})x(\d{2,5})[._]/) || src.match(/[?&]width=(\d{2,5})&(?:amp;)?height=(\d{2,5})/);
        if(m){
          img.style.aspectRatio = m[1] + ' / ' + m[2];
        } else {
          var setRatio = function(){
            if(img.naturalWidth && img.naturalHeight && !img.style.aspectRatio){
              img.style.aspectRatio = img.naturalWidth + ' / ' + img.naturalHeight;
            }
          };
          if(img.complete) setRatio();
          else img.addEventListener('load', setRatio, { once: true });
        }
      });

      /* ---- Wrap tables in a horizontal-scroll container ----
         Merchant tables (esp. wide research tables with DOI/URL columns) use
         table-layout:auto, so long cell content forces the table wider than the
         .wb-body column and it overflows to the right under the sidebar. Wrapping
         each table lets it scroll inside its own box instead of breaking layout. */
      Array.prototype.forEach.call(wbBodyEl.querySelectorAll('table'), function(table){
        if(table.parentNode && table.parentNode.classList.contains('wb-table-wrap')) return;
        var wrap = document.createElement('div');
        wrap.className = 'wb-table-wrap';
        table.parentNode.insertBefore(wrap, table);
        wrap.appendChild(table);
      });
    }

    /* ---- Build Table of Contents from the real article headings ---- */
    var body = root.querySelector('.wb-body');

    /* Hide inline Disclaimer paragraphs from article content (all blogs) */
    /* Disabled: inline-disclaimer detection turned off
    if(body){
      Array.prototype.forEach.call(body.querySelectorAll('p'), function(p){
        if(p.classList.contains('wb-disclaimer')) return;
        var text = (p.textContent || '').replace(/\s+/g, ' ').trim();
        if(/^disclaimer\s*:?/i.test(text)) p.classList.add('wb-inline-disclaimer');
      });
    }
    */

    /* Wrap citation links numbered 1–20 in <sup> — blog article page only */
    if(body && document.body.classList.contains('template-article')){
      var articleBody = body.querySelector('[itemprop="articleBody"]') || body;
      Array.prototype.forEach.call(articleBody.querySelectorAll('a[href]'), function(a){
        if(a.closest('.wb-disclaimer, .wb-ref-wrap, .wb-prod')) return;
        if(a.querySelector('sup')) return;
        var href = a.getAttribute('href') || '';
        if(!/^https?:\/\//i.test(href)) return;
        var text = (a.textContent || '').replace(/\s+/g, '').trim();
        if(/^(?:[1-9]|1[0-9]|20)$/.test(text)){
          a.classList.add('wb-cite-link');
          a.style.textDecoration = 'none';
          a.style.textUnderlineOffset = '0';
          a.innerHTML = '<sup>' + text + '</sup>';
        }
      });
    }

    var tocListEl = root.querySelector('.wb-toc-list');
    var includeH3 = body && body.getAttribute('data-include-h3') === 'true';
    var heads = body ? body.querySelectorAll(includeH3 ? 'h2, h3' : 'h2') : [];
    var headingIds = [];

    function slugify(t){
      return (t || '').toLowerCase().trim()
        .replace(/[^\w\s-]/g, '')
        .replace(/\s+/g, '-')
        .replace(/-+/g, '-')
        .substring(0, 60) || 'section';
    }

    Array.prototype.forEach.call(heads, function(h, i){
      var text = (h.textContent || '').trim();
      if(!text) return;
      if(/^references?[:.]?\s*$/i.test(text)) return; /* skip References from TOC */
      var id = h.id;
      if(!id){
        /* clean, readable hash (#what-is-x); -2, -3 … only when the slug is already taken */
        var base = slugify(text), n = 1;
        id = base;
        while(document.getElementById(id)){ n++; id = base + '-' + n; }
        h.id = id;
      }
      headingIds.push(id);
      h.style.scrollMarginTop = '90px';
      var isSub = h.tagName.toLowerCase() === 'h3';
      function makeItem(){
        var li = document.createElement('li');
        if(isSub) li.className = 'sub';
        var a = document.createElement('a');
        a.href = '#' + id;
        a.textContent = text;
        li.appendChild(a);
        return li;
      }
      if(tocListEl) tocListEl.appendChild(makeItem());
    });

    /* No headings → drop the empty desktop TOC column */
    if(headingIds.length === 0){
      var wrap = document.getElementById('wbWrap');
      if(wrap) wrap.classList.add('wb-no-toc');
      var tocAside = root.querySelector('.wb-toc');
      if(tocAside) tocAside.style.display = 'none';
    }

    /* ---- Smooth scroll for TOC sidebar links ---- */
    var tocLinks = root.querySelectorAll('.wb-toc a');
    var headerOffset = 90;
    Array.prototype.forEach.call(tocLinks, function(a){
      a.addEventListener('click', function(e){
        var href = a.getAttribute('href') || '';
        if(href.charAt(0) !== '#') return;
        e.preventDefault();
        var el = document.getElementById(href.slice(1));
        if(el){
          var y = el.getBoundingClientRect().top + window.pageYOffset - headerOffset;
          window.scrollTo({ top: y, behavior: 'smooth' });
          if(history.replaceState) history.replaceState(null, '', href);
        }
      });
    });

    /* Shared link with #heading-slug: the ids are created by this script, so the browser
       could not jump there on load – do it now. */
    if(location.hash.length > 1){
      var hashEl = document.getElementById(decodeURIComponent(location.hash.slice(1)));
      if(hashEl && headingIds.indexOf(hashEl.id) > -1){
        window.scrollTo({ top: hashEl.getBoundingClientRect().top + window.pageYOffset - headerOffset });
      }
    }

    /* ---- Scroll-spy ---- */
    function onScroll(){
      var active = headingIds.length ? headingIds[0] : null;
      for(var i=0;i<headingIds.length;i++){
        var el = document.getElementById(headingIds[i]);
        if(el && el.getBoundingClientRect().top - 100 <= 0) active = headingIds[i];
      }
      if(active){
        Array.prototype.forEach.call(tocLinks, function(a){
          a.classList.toggle('active', a.getAttribute('href') === '#'+active);
        });
      }
    }
    /* Throttle to one run per animation frame. The raw handler reads layout
       (getBoundingClientRect on every heading + scrollHeight) which, fired on
       every scroll event, caused jank on low-power phones. rAF coalesces the
       bursts so it runs at most once per painted frame. */
    var wbScrollTicking = false;
    function wbOnScroll(){
      if(wbScrollTicking) return;
      wbScrollTicking = true;
      window.requestAnimationFrame(function(){ onScroll(); wbScrollTicking = false; });
    }
    window.addEventListener('scroll', wbOnScroll, { passive:true });
    onScroll();

    /* ---- Collapsible References ---- */
    /* Deferred to idle: this is the heaviest main-thread work on the page
       (whole-article innerHTML reads + per-reference regex parsing) and it only
       transforms a below-the-fold section — so it must not block first paint or
       initial interactivity on mobile. */
    function wbBuildReferences(){
      if(!body) return;
      var wbCitations = [];
      var bookSvg = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20"/><path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z"/></svg>';
      var chevronSvg = '<svg class="wb-ref-chevron" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="6 9 12 15 18 9"/></svg>';
      var extSvg = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"/><polyline points="15 3 21 3 21 9"/><line x1="10" y1="14" x2="21" y2="3"/></svg>';
      var REF_PREVIEW = 5;

      function isRefHeadingText(text){
        return /^references?\s*:?\s*$/i.test((text || '').replace(/\s+/g, ' ').trim());
      }

      function findReferenceHeading(root){
        if(root.querySelector('.wb-ref-wrap')) return null;
        var match = null;
        Array.prototype.forEach.call(root.querySelectorAll('h4'), function(el){
          if(el.closest('.wb-ref-wrap')) return;
          var text = (el.textContent || '').replace(/\s+/g, ' ').trim();
          if(isRefHeadingText(text)) match = el;
        });
        return match;
      }

      function collectRefNodesAfter(heading, root){
        var nodes = [];
        var cur = heading;
        while(cur && cur !== root){
          var sib = cur.nextSibling;
          while(sib){
            if(sib.nodeType === 1){
              if(sib.classList && sib.classList.contains('wb-disclaimer')) return nodes;
              if(sib.classList && sib.classList.contains('wb-ref-wrap')) return nodes;
            }
            nodes.push(sib);
            sib = sib.nextSibling;
          }
          cur = cur.parentNode;
        }
        return nodes;
      }

      function removeRefHeading(heading, root){
        var target = heading;
        while(target.parentNode && target.parentNode !== root){
          var par = target.parentNode;
          var meaningful = 0;
          Array.prototype.forEach.call(par.childNodes, function(n){
            if(n.nodeType === 3 && !(n.textContent || '').trim()) return;
            meaningful++;
          });
          if(meaningful === 1) target = par;
          else break;
        }
        if(target && target.parentNode) target.parentNode.removeChild(target);
      }

      function getRefSourceEls(container){
        var items = [];
        var lis = container.querySelectorAll('li');
        if(lis.length){
          Array.prototype.forEach.call(lis, function(li){
            var t = (li.textContent || '').replace(/\s+/g, ' ').trim();
            if(t && !isRefHeadingText(t)) items.push(li);
          });
          if(items.length) return items;
        }
        var wrappers = container.querySelectorAll('div[class*="ListContainerWrapper"]');
        if(wrappers.length){
          Array.prototype.forEach.call(wrappers, function(w){ items.push(w); });
          return items;
        }
        Array.prototype.forEach.call(container.querySelectorAll('p'), function(p){
          var t = (p.textContent || '').replace(/\s+/g, ' ').trim();
          if(!t || isRefHeadingText(t)) return;
          if(/https?:\/\//.test(t) || /^\d+[\.\)]\s/.test(t) || p.querySelector('a[href*="http"]')){
            items.push(p);
          }
        });
        return items;
      }

      function parseReference(el){
        var link = el.querySelector('a[href]');
        var url = link && link.href ? link.href : '';
        var fullText = (el.textContent || '').replace(/\s+/g, ' ').trim();
        fullText = fullText.replace(/^\d+[\.\)]\s*/, '');

        if(!url){
          var urlMatch = fullText.match(/https?:\/\/[^\s<>"']+/);
          if(urlMatch) url = urlMatch[0].replace(/[.,;)\]]+$/, '');
        }

        var text = fullText.replace(/\s*https?:\/\/\S+\s*/g, ' ').replace(/\s+/g, ' ').trim();
        text = text.replace(/\.$/, '');

        var title = text;
        var meta = '';
        var pubYear = '';
        var yearInCite = text.match(/\((20\d{2}|19\d{2})\)/);
        if(yearInCite) pubYear = yearInCite[1];

        var journalMatch = text.match(/^(.+?)\.\s+([^\.]+,\s*20\d{2})$/);
        if(journalMatch){
          var mainPart = journalMatch[1];
          meta = journalMatch[2];
          var yearParen = mainPart.match(/^(?:.+?\(\d{4}\)\.\s*)(.+)$/);
          if(yearParen){
            title = yearParen[1];
          } else if(mainPart.indexOf('. ') > -1){
            var segs = mainPart.split(/\.\s+/);
            title = segs[segs.length - 1];
          } else {
            title = mainPart;
          }
        } else if(text.indexOf('). ') > -1){
          var afterYear = text.split('). ').pop();
          var parts = afterYear.split(/\.\s+/);
          title = parts[0] || text;
          if(parts.length > 1){
            var journalPart = parts.slice(1).join('. ').replace(/,?\s*\d+,?\s*\d+\.?\s*$/, '').trim();
            meta = pubYear ? journalPart + ', ' + pubYear : journalPart;
          }
        }

        return {
          title: title || fullText,
          meta: meta,
          url: url,
          fullHtml: el.innerHTML
        };
      }

      function buildRefItem(ref, index){
        var item = document.createElement('div');
        item.className = 'wb-ref-item';
        if(index >= REF_PREVIEW) item.classList.add('wb-ref-item--hidden');

        var num = document.createElement('span');
        num.className = 'wb-ref-num';
        num.textContent = (index + 1) + '.';

        var main = document.createElement('div');
        main.className = 'wb-ref-main';

        var titleEl = document.createElement('div');
        titleEl.className = 'wb-ref-item-title';
        titleEl.textContent = ref.title;

        main.appendChild(titleEl);

        if(ref.meta){
          var metaEl = document.createElement('div');
          metaEl.className = 'wb-ref-item-meta';
          metaEl.textContent = ref.meta;
          main.appendChild(metaEl);
        }

        var fullEl = document.createElement('div');
        fullEl.className = 'wb-ref-item-full';
        fullEl.innerHTML = ref.fullHtml;
        main.appendChild(fullEl);

        item.appendChild(num);
        item.appendChild(main);

        if(ref.url){
          var view = document.createElement('a');
          view.className = 'wb-ref-view';
          view.href = ref.url;
          view.target = '_blank';
          view.rel = 'noopener noreferrer';
          view.innerHTML = 'View Study ' + extSvg;
          item.appendChild(view);
        }

        return item;
      }

      function buildReferencesUI(heading, sourceEls){
        var refs = sourceEls.map(parseReference).filter(function(ref){
          return ref.title || ref.url;
        });
        if(!refs.length) return null;

        refs.forEach(function(ref){
          var citeName = ref.title.length > 250 ? ref.title.slice(0, 247) + '…' : ref.title;
          var cite = { "@type": "ScholarlyArticle", "name": citeName };
          if(ref.url) cite.url = ref.url;
          wbCitations.push(cite);
        });

        var refCount = refs.length;
        var refWrap = document.createElement('div');
        refWrap.className = 'wb-ref-wrap';

        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'wb-ref-toggle';
        btn.setAttribute('aria-expanded', 'false');
        var refTitle = (heading.textContent || '').trim().replace(/[:.]?\s*$/, '') || 'References';
        var badgeHtml = refCount > 0 ? '<span class="wb-ref-badge">' + refCount + '</span>' : '';
        btn.innerHTML =
          '<span class="wb-ref-label">'
          + '<span class="wb-ref-icon-wrap">' + bookSvg + '</span>'
          + '<span class="wb-ref-title">' + refTitle + '</span>'
          + badgeHtml
          + '</span>'
          + '<span class="wb-ref-right">'
          + '<span class="wb-ref-hint">View</span>'
          + '<span class="wb-ref-chevron-wrap">' + chevronSvg + '</span>'
          + '</span>';

        var refBody = document.createElement('div');
        refBody.className = 'wb-ref-body';
        var refInner = document.createElement('div');
        refInner.className = 'wb-ref-inner';

        var sourcing = document.createElement('p');
        sourcing.className = 'wb-ref-sourcing';
        sourcing.innerHTML = '<a href="https://wellnessextract.com/">Wellness extract</a> has strict sourcing guidelines and relies on peer-reviewed studies, academic research institutions, and medical journals and associations. We only use quality, credible sources to ensure content accuracy and integrity. You can learn more about how we ensure our content is accurate and current by reading our <a href="https://wellnessextract.com/pages/editorial-process">editorial process</a>.';
        refInner.appendChild(sourcing);

        var intro = document.createElement('p');
        intro.className = 'wb-ref-intro';
        intro.textContent = 'The studies below support the information in this article.';
        refInner.appendChild(intro);

        var refList = document.createElement('div');
        refList.className = 'wb-ref-list';
        refs.forEach(function(ref, i){
          refList.appendChild(buildRefItem(ref, i));
        });
        refInner.appendChild(refList);

        var moreBtn = document.createElement('button');
        moreBtn.type = 'button';
        moreBtn.className = 'wb-ref-more' + (refCount <= REF_PREVIEW ? ' wb-ref-more--hidden' : '');
        moreBtn.setAttribute('aria-expanded', 'false');
        moreBtn.innerHTML = 'View all ' + refCount + ' references ' + chevronSvg;
        refInner.appendChild(moreBtn);

        refBody.appendChild(refInner);
        refWrap.appendChild(btn);
        refWrap.appendChild(refBody);

        btn.addEventListener('click', function(){
          var isOpen = btn.getAttribute('aria-expanded') === 'true';
          if(isOpen){
            refBody.style.maxHeight = refBody.scrollHeight + 'px';
            requestAnimationFrame(function(){
              refBody.style.maxHeight = '0';
            });
            btn.setAttribute('aria-expanded', 'false');
          } else {
            refBody.style.maxHeight = refBody.scrollHeight + 'px';
            btn.setAttribute('aria-expanded', 'true');
            refBody.addEventListener('transitionend', function cleanup(){
              refBody.style.maxHeight = 'none';
              refBody.removeEventListener('transitionend', cleanup);
            });
          }
        });

        moreBtn.addEventListener('click', function(){
          var expanded = moreBtn.getAttribute('aria-expanded') === 'true';
          var allItems = refList.querySelectorAll('.wb-ref-item');

          if(expanded){
            Array.prototype.forEach.call(allItems, function(el, i){
              if(i >= REF_PREVIEW) el.classList.add('wb-ref-item--hidden');
            });
            moreBtn.setAttribute('aria-expanded', 'false');
            moreBtn.innerHTML = 'View all ' + refCount + ' references ' + chevronSvg;
          } else {
            Array.prototype.forEach.call(allItems, function(el){
              el.classList.remove('wb-ref-item--hidden');
            });
            moreBtn.setAttribute('aria-expanded', 'true');
            moreBtn.innerHTML = 'Show fewer references ' + chevronSvg;
          }
          if(btn.getAttribute('aria-expanded') === 'true'){
            refBody.style.maxHeight = refInner.scrollHeight + 'px';
            requestAnimationFrame(function(){
              refBody.style.maxHeight = 'none';
            });
          }
        });

        return refWrap;
      }

      var refHeading = findReferenceHeading(body);
      if(refHeading){
        var refNodes = collectRefNodesAfter(refHeading, body);
        if(refNodes.length){
          var disclaimer = body.querySelector('.wb-disclaimer');
          var refTemp = document.createElement('div');
          refNodes.forEach(function(n){ refTemp.appendChild(n); });

          var refSourceEls = getRefSourceEls(refTemp);

          function restoreRefNodes(){
            if(!disclaimer || !disclaimer.parentNode) return;
            while(refTemp.firstChild){
              disclaimer.parentNode.insertBefore(refTemp.firstChild, disclaimer);
            }
          }

          function insertRefWrap(refWrapEl){
            if(disclaimer && disclaimer.parentNode){
              disclaimer.parentNode.insertBefore(refWrapEl, disclaimer);
            } else {
              body.appendChild(refWrapEl);
            }
          }

          if(refSourceEls.length){
            removeRefHeading(refHeading, body);
            var refWrapEl = buildReferencesUI(refHeading, refSourceEls);
            if(refWrapEl){
              insertRefWrap(refWrapEl);
            } else {
              restoreRefNodes();
            }
          } else {
            restoreRefNodes();
          }
        }
      }

      if(wbCitations.length){
        var ldEl = document.getElementById('wb-article-jsonld');
        if(ldEl){
          try{
            var ldData = JSON.parse(ldEl.textContent);
            ldData.citation = wbCitations;
            ldEl.textContent = JSON.stringify(ldData);
          }catch(e){}
        }
      } else if(body){
        var refMatch = body.innerHTML.match(/References\s*:/i);
        if(refMatch){
          var refStart = body.innerHTML.indexOf(refMatch[0]) + refMatch[0].length;
          var refSection = body.innerHTML.slice(refStart);
          var discIdx = refSection.search(/Disclaimer/i);
          if(discIdx > 0) refSection = refSection.slice(0, discIdx);
          var refTmp = document.createElement('div');
          refTmp.innerHTML = refSection;
          getRefSourceEls(refTmp).forEach(function(el){
            var ref = parseReference(el);
            if(!ref.url) return;
            var citeName = ref.title.length > 250 ? ref.title.slice(0, 247) + '…' : ref.title;
            wbCitations.push({ "@type": "ScholarlyArticle", "name": citeName, "url": ref.url });
          });
          if(wbCitations.length){
            var ldEl2 = document.getElementById('wb-article-jsonld');
            if(ldEl2){
              try{
                var ldData2 = JSON.parse(ldEl2.textContent);
                ldData2.citation = wbCitations;
                ldEl2.textContent = JSON.stringify(ldData2);
              }catch(e2){}
            }
          }
        }
      }
    }
    /* Run the references build when the main thread is idle. requestIdleCallback
       is unsupported on older iOS Safari, where the setTimeout fallback still
       yields to let the browser paint first, then runs the work. */
    if('requestIdleCallback' in window){
      requestIdleCallback(wbBuildReferences, { timeout: 2500 });
    } else {
      setTimeout(wbBuildReferences, 1);
    }

    /* ---- Inject dynamic product card(s) into in-content placeholder(s) ----
       Place a div whose id matches a product tag anywhere in the article body, e.g.
       <div id="vitamin-e-tocotrienol-mobile"></div>. The product carrying that tag
       is fetched from /collections/all/<tag>?view=blog-product and injected.
       MOBILE/TABLET ONLY — on desktop the sidebar (.wb-side) already shows products,
       so .wb-inline-prod is hidden via CSS below 1025px only. */
    (function injectInlineProducts(){
      var blogProductTags = [
        'vitamin-e-tocotrienol-mobile',
        'astaxanthin-mobile',
        'gg-essential-mobile',
        'bio-qunol-mobile',
        'cell-dtox-mobile',
        'bovine-colostrum-mobile',
        'vitamine-eannatto-gg-mobile',
        'h2-tablets-mobile',
        'coffee-enema-mobile',
        'electric-frother-mobile',
        'coffee-enema-kit-mobile',
        'colostrum-pets-mobile',
        /* Bundle products — render via the same blog-product view (wb-product-card),
           which shows the custom.bundle_product_title metafield as the card title. */
        'skin-health-bundle-mobile',
        'gut-health-trio-bundle-mobile',
        'healthy-aging-bundle-mobile',
        'bone-health-bundle-mobile',
        'heart-health-bundle-mobile',
        'eye-health-bundle-mobile',
        'immune-health-bundle-mobile',
        'brain-health-bundle-mobile',
        'muscle-health-bundle-mobile',
        'body-detox-bundle-mobile',
        'hormone-health-bundle-mobile'
      ];

      var targets = [];
      blogProductTags.forEach(function(tag){
        Array.prototype.forEach.call(
          document.querySelectorAll('[id="' + tag + '"]'),
          function(el){
            if(targets.indexOf(el) === -1) targets.push(el);
          }
        );
      });
      if(!targets.length) return;

      targets.forEach(function(target){
        if(target.getAttribute('data-wb-filled')) return;
        var tag = (target.id || '').trim().toLowerCase();
        if(!tag){ target.style.display = 'none'; return; }
        target.setAttribute('data-wb-filled', '1');

        var url = '/collections/all/' + encodeURIComponent(tag) + '?view=blog-product';
        fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
          .then(function(r){ return r.ok ? r.text() : ''; })
          .then(function(html){
            html = (html || '').trim();
            if(!html){ target.style.display = 'none'; return; }
            var wrap = document.createElement('div');
            wrap.className = 'wb-inline-prod';
            wrap.innerHTML = html;
            if(!wrap.querySelector('.wb-prod')){ target.style.display = 'none'; return; }
            target.innerHTML = '';
            target.appendChild(wrap);
            if(window.okeWidgetApi && typeof window.okeWidgetApi.initWidgets === 'function'){
              try{ window.okeWidgetApi.initWidgets(); }catch(e){}
            }
          })
          .catch(function(){ target.style.display = 'none'; });
      });
    })();

    /* ---- Related Posts Slider ---- */
    /* Cards are injected asynchronously (fetched from the tag-filtered blog view),
       so the slider is exposed as window.wbInitRelSlider() and called once the
       cards land. It is idempotent — listeners are bound only on first init. */
    var relTrack    = document.getElementById('wbRelTrack');
    var relViewport = document.getElementById('wbRelViewport');
    var relPrevBtn  = document.getElementById('wbRelPrev');
    var relNextBtn  = document.getElementById('wbRelNext');
    var relDotsWrap = document.getElementById('wbRelDots');

    var relCards = [], relTotal = 0, relVisible = 3, relIndex = 0, relBound = false;

    function relGetVisible(){
      var w = window.innerWidth;
      if(w <= 550) return 1;
      if(w <= 1024) return 2;
      return 3;
    }

    function relCardWidth(){
      if(!relCards[0]) return 0;
      var style = window.getComputedStyle(relTrack);
      var gap = parseFloat(style.gap || style.columnGap) || 20;
      return relCards[0].offsetWidth + gap;
    }

    function goToRel(idx){
      var maxIdx = Math.max(0, relTotal - relVisible);
      relIndex = Math.max(0, Math.min(idx, maxIdx));
      relTrack.style.transform = 'translateX(-' + (relIndex * relCardWidth()) + 'px)';
      if(relPrevBtn) relPrevBtn.disabled = relIndex === 0;
      if(relNextBtn) relNextBtn.disabled = relIndex >= maxIdx;
      var activePage = Math.floor(relIndex / relVisible);
      if(relDotsWrap){
        Array.prototype.forEach.call(relDotsWrap.querySelectorAll('.wb-rel-dot'), function(dot, i){
          dot.classList.toggle('active', i === activePage);
        });
      }
    }

    window.wbInitRelSlider = function(){
      if(!relTrack || !relViewport) return;
      relCards   = relTrack.querySelectorAll('.wb-rel-card');
      relTotal   = relCards.length;
      relVisible = relGetVisible();
      relIndex   = 0;

      /* (re)build dot indicators */
      if(relDotsWrap){
        relDotsWrap.innerHTML = '';
        var relPageCount = Math.ceil(relTotal / relVisible);
        if(relPageCount > 1){
          for(var d = 0; d < relPageCount; d++){
            var dot = document.createElement('button');
            dot.className = 'wb-rel-dot' + (d === 0 ? ' active' : '');
            dot.type = 'button';
            dot.setAttribute('aria-label', 'Go to slide ' + (d + 1));
            (function(idx){ dot.addEventListener('click', function(){ goToRel(idx * relVisible); }); })(d);
            relDotsWrap.appendChild(dot);
          }
        }
      }

      /* bind interaction listeners only once */
      if(!relBound){
        relBound = true;
        if(relPrevBtn) relPrevBtn.addEventListener('click', function(){ goToRel(relIndex - relVisible); });
        if(relNextBtn) relNextBtn.addEventListener('click', function(){ goToRel(relIndex + relVisible); });
        window.addEventListener('resize', function(){
          relVisible = relGetVisible();
          goToRel(relIndex);
        }, { passive:true });
        var relTouchX = 0;
        relViewport.addEventListener('touchstart', function(e){ relTouchX = e.touches[0].clientX; }, { passive:true });
        relViewport.addEventListener('touchend', function(e){
          var dx = e.changedTouches[0].clientX - relTouchX;
          if(Math.abs(dx) > 40){ goToRel(relIndex + (dx < 0 ? relVisible : -relVisible)); }
        }, { passive:true });
      }

      goToRel(0);
    };

    /* if cards were already present (e.g. server-rendered), init now */
    if(relTrack && relTrack.querySelectorAll('.wb-rel-card').length){
      window.wbInitRelSlider();
    }

    /* ---- FAQ Schema (SEO) ----
       Builds a FAQPage JSON-LD block dynamically from the article's FAQ section.
       Detection: a heading whose text is "Frequently Asked Questions" / "FAQs".
       Each deeper heading after it is a Question; the paragraph(s) that follow it
       (until the next heading) are its Answer. No hardcoding — fully dynamic. */
    (function injectFaqSchema(){
      if(!body) return;
      if(document.getElementById('wb-faq-jsonld')) return; /* run once */

      function clean(el){
        return (el.textContent || '')
          .replace(/ /g, ' ')   /* &nbsp; → space */
          .replace(/\s+/g, ' ')
          .trim();
      }
      function headingLevel(el){
        return /^H[1-6]$/.test(el.tagName) ? parseInt(el.tagName.charAt(1), 10) : 0;
      }

      /* Locate the FAQ heading */
      var faqHeading = null;
      var allHeads = body.querySelectorAll('h1, h2, h3, h4, h5, h6');
      for(var i = 0; i < allHeads.length; i++){
        var t = clean(allHeads[i]).replace(/[:.]?\s*$/, '');
        if(/^(frequently asked questions.*|faqs?)$/i.test(t)){ faqHeading = allHeads[i]; break; }
      }
      if(!faqHeading) return;

      var faqLevel = headingLevel(faqHeading);

      /* Walk headings + paragraphs in document order after the FAQ heading */
      var nodes = body.querySelectorAll('h1, h2, h3, h4, h5, h6, p');
      var started = false, current = null, faqs = [];

      Array.prototype.forEach.call(nodes, function(el){
        if(el === faqHeading){ started = true; return; }
        if(!started || current === false) return;

        /* Ignore references, citations, product cards and disclaimers —
           their paragraphs/headings are not part of any FAQ answer. */
        if(el.closest('.wb-ref-wrap, .wb-prod, .wb-inline-prod, .wb-disclaimer')) return;

        var lvl = headingLevel(el);
        if(lvl){
          /* References / Disclaimer heading ends the FAQ section. (References may
             not yet be wrapped in .wb-ref-wrap when this runs, so match by text.) */
          var htext = clean(el).replace(/[:.]?\s*$/, '');
          if(/^references?$/i.test(htext) || /^disclaimer\b/i.test(htext)){ current = false; return; }
          /* Another same/higher-level heading ends the FAQ section */
          if(lvl <= faqLevel){ current = false; return; }
          /* Deeper heading = a new question */
          var q = clean(el).replace(/\s*$/, '');
          current = q ? { q: q, a: '' } : null;
          if(current) faqs.push(current);
          return;
        }
        /* Paragraph = part of the current answer */
        if(current && el.tagName === 'P' && !el.classList.contains('wb-disclaimer')){
          var a = clean(el);
          if(a) current.a = current.a ? (current.a + ' ' + a) : a;
        }
      });

      var valid = faqs.filter(function(f){
        return f.q && f.a &&
          !/^references?\b/i.test(f.q) &&   /* never treat References as a question */
          !/^disclaimer\b/i.test(f.q);
      });
      if(!valid.length) return;

      var schema = {
        "@context": "https://schema.org",
        "@type": "FAQ Schema",
        "mainEntity": valid.map(function(f){
          return {
            "@type": "Question",
            "name": f.q,
            "acceptedAnswer": { "@type": "Answer", "text": f.a }
          };
        })
      };

      var script = document.createElement('script');
      script.type = 'application/ld+json';
      script.id = 'wb-faq-jsonld';
      script.textContent = JSON.stringify(schema);
      document.head.appendChild(script);
    })();

  })();
